import { Link } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import "./PoliciesUsage.css";

const PoliciesUsage = () => {
  useEffect(() => {
    // Scroll to top on component mount
    window.scrollTo(0, 0);
  }, []);
  const policies = [
    { id: 1, title: "Term & Conditions of Donation" },
    { id: 2, title: "Terms & Conditions of Book Store" },
    { id: 3, title: "Privacy Policy of Book Store" },
    { id: 4, title: "Return and Refund Policy of Book Store" },
    { id: 5, title: "Shipping & Delivery Policy of Book Store" },
    { id: 6, title: "Guidelines to Please Krishna During Purushottam Month" },
    { id: 7, title: "Term & Conditions" },
  ];

  // Helper function to create slugs from titles
  const createSlug = (title) =>
    title
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "");

  return (
    <>
      <Helmet>
        <title>ISKCON Vijayawada Website Policies & Terms of Use</title>
        <meta
          name="description"
          content="Review ISKCON Vijayawada’s website usage policies, terms of service, privacy practices, and content guidelines for a safe and respectful experience."
        />
        <meta
          name="keywords"
          content="ISKCON website terms, usage policy ISKCON, privacy policy ISKCON Vijayawada, site terms"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="ISKCON Vijayawada" />
        <meta
          property="og:title"
          content="ISKCON Vijayawada Website Policies & Terms of Use"
        />
        <meta
          property="og:description"
          content="Review ISKCON Vijayawada’s website usage policies, terms of service, privacy practices, and content guidelines for a safe and respectful experience."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.iskconvijayawada.org/policies-usage"
        />
        <meta
          property="og:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="ISKCON Vijayawada Website Policies & Terms of Use"
        />
        <meta
          name="twitter:description"
          content="Review ISKCON Vijayawada’s website usage policies, terms of service, privacy practices, and content guidelines for a safe and respectful experience."
        />
        <meta
          name="twitter:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />

        {/* Canonical URL */}
        <link
          rel="canonical"
          href="https://www.iskconvijayawada.org/policies-usage"
        />
      </Helmet>

      <Header />
      <div className="mx-auto p-6 w-[70%] pt-16">
        <nav className="text-sm text-slate-600  mb-4">
          <Link
            to="/"
            className="hover:underline no-underline text-slate-950 font-bold"
          >
            Home
          </Link>{" "}
          &gt; Policies of Usage
        </nav>

        <div className="policies-usage-section-heading">
          <h1 className="policies-usage-heading">
            Website Policies & Terms of Use – ISKCON Vijayawada
          </h1>
          <h2 className="policies-usage-subheading">
            Learn About Privacy, Usage Rules, and Data Handling
          </h2>
        </div>
        <h1 className="text-2xl font-bold text-[#c61d21] mb-4">
          Policies of Usage
        </h1>

        <ul className="list-decimal ml-5 text-[#c61d21] ">
          {policies.map((policy) => (
            <li key={policy.id} className="mb-2 ">
              <Link
                to={`/policies-usage/${createSlug(policy.title)}`}
                className="hover:underline no-underline text-[#c61d21] text-xl font-['Inter']"
              >
                {policy.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <Footer />
    </>
  );
};

export default PoliciesUsage;
